import { ref, nextTick } from 'vue'
import { isEmpty } from '@/common/js/utils'

export const useQueryParamsManager = (filterRef) => {
  const queryParamsManagerRef = ref(null)

  const onSaveConditions = () => {
    nextTick(() => {
      if (filterRef.value && queryParamsManagerRef.value) {
        const params = filterRef.value.buildParams()
        console.log('paramsparamsparams output: ', params)

        queryParamsManagerRef.value.openSaveDialog(params)
      }
    })
  }

  const onConditionSelect = (cond) => {
    if (filterRef.value && cond) {
      const { conditionInfo } = cond
      if (!isEmpty(conditionInfo)) {
        let projectGroupId, keyword, searchType
        const parsedInfo = JSON.parse(conditionInfo)
        const {
          planName,
          imageName,
          landingPageIdStr,
          adAccountId,
          gameId,
          gameGroupId,
          opId,
          projectGroupOpIds,
          mediaId,
          subMediaId,
          platform,
          advPositionId,
          optimizationType,
          deepOptimizationType,
          bindMaterial,
          mediaStatusStr,
          mediaOptStatusStr,
          proxyFlag,
          compareConditions
        } = parsedInfo

        let mediaStatusArr = []
        let mediaOptStatusArr = []

        if (!isEmpty(projectGroupOpIds)) projectGroupId = projectGroupOpIds.split(',').map((ret) => Number(ret))
        if (!isEmpty(mediaStatusStr)) mediaStatusArr = mediaStatusStr.split(',').map((ret) => Number(ret))
        if (!isEmpty(mediaOptStatusStr)) mediaOptStatusArr = mediaOptStatusStr.split(',').map((ret) => Number(ret))

        if (!isEmpty(planName)) {
          keyword = planName
          searchType = 1
        } else if (!isEmpty(imageName)) {
          keyword = imageName
          searchType = 2
        } else if (!isEmpty(landingPageIdStr)) {
          keyword = landingPageIdStr
          searchType = 3
        }

        nextTick(() => {
          const filterForm = {
            projectGroupId: projectGroupId || '',
            adAccountId: adAccountId || '',
            gameId: gameId || '',
            gameGroupId: gameGroupId || '',
            opId: opId || '',
            mediaId: mediaId || '',
            subMediaId: subMediaId || '',
            platform: platform ? (Number(platform) ? platform : '') : '',
            advPositionId: advPositionId || '',
            optimizationType: optimizationType || '',
            deepOptimizationType: deepOptimizationType || '',
            keyword: keyword || '',
            searchType: searchType || 1,
            bindMaterial: bindMaterial || '',
            mediaStatus: mediaStatusArr,
            mediaOptStatus: mediaOptStatusArr,
            proxyFlag: proxyFlag || '',
            compareConditions: compareConditions || []
          }
          filterRef.value.setFormData(filterForm)
        })
      }
    }
  }

  return {
    queryParamsManagerRef,
    onSaveConditions,
    onConditionSelect
  }
}
